<template>
  <div class="activity-tabs fixed-tabs" :class="{'due-payments':activeIndex==1}">

    <div id="non-printable">
      <v-toolbar fixed tabs dense flat>

        <v-tabs v-model="activeIndex" slider-color="primary" @input="fn_tabChange">
          <v-tab v-for="(tab, index) in tabs" :key="index" ripple>{{tab.title}}</v-tab>
        </v-tabs>

      </v-toolbar>

      <v-tabs-items v-model="activeIndex" @input="fn_tabChange">

        <!-- <v-tab-item>  
          <keep-alive>
            <component :is="currentTabComponent" ref="ref_dashboard"></component>
          </keep-alive>
        </v-tab-item> -->

        <v-tab-item>
          <keep-alive>
            <component :is="currentTabComponent" ref="ref_transactions" :preview="fn_preview" :bindInvoiceTemplate="fn_bindInvoiceTemplate" :add="fn_add" :getFormNameByListId="$root.fn_getFormNameByListId"></component>
          </keep-alive>
        </v-tab-item>

        <v-tab-item>  
          <keep-alive>
            <component :is="currentTabComponent" ref="ref_duePayments" :add="fn_add"></component>
          </keep-alive>
        </v-tab-item>

        <v-tab-item>  
          <keep-alive>
            <component :is="currentTabComponent" ref="ref_items" :add="fn_add"></component>
          </keep-alive>
        </v-tab-item>

        <v-tab-item>  
          <keep-alive>
            <component :is="currentTabComponent" ref="ref_orders" :preview="fn_preview" :bindInvoiceTemplate="fn_bindInvoiceTemplate" :add="fn_add"></component>
          </keep-alive>
        </v-tab-item>

        <v-tab-item>  
          <keep-alive>
            <component :is="currentTabComponent" ref="ref_invoices" :preview="fn_preview" :bindInvoiceTemplate="fn_bindInvoiceTemplate" :showBottomNavigation="fn_showBottomNavigation" :hideBottomNavigation="fn_hideBottomNavigation"></component>
          </keep-alive>
        </v-tab-item>

      </v-tabs-items>

      <payment-reminder-card></payment-reminder-card>

      <!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->

      <!-- binding in the background to calculate full page height for header, body and footer -->
      <div id="hidden_invoice_preview" v-if="$root.TransactionSettings.fullPagePrint">
				<component :is="previewTemplate" ref="ref_previewTemplate" :data="printData" v-if="previewTemplate && printData!=null"></component>
			</div>
    </div> 

    <div id="printable" full-width>
      <component :is="printTemplate" ref="ref_printTemplate" :data="printData" v-if="printTemplate && printData!=null"></component>
    </div>

    <!-- <div id="printable-area" white-background full-width>
      <ledger-statement ref="ref_ledgerStatement" :statementData="statementData" v-if="statementData"></ledger-statement>
    </div> -->

    <dialog-transaction-options ref="ref_dialogTransactionOptions" :showAll="true" :showPartyOptions="false"></dialog-transaction-options>

    <!-- <v-btn Capitalize dark absolute bottom center style="bottom:16px;background-color: #ddd !important;border-radius: 10px;left: 0;right: 0;margin: auto;color:rgba(0,0,0,0.87)" @click="fn_add">
      New {{activeIndex == 0 ? 'Transaction' : activeIndex == 1 ? 'Party' : activeIndex == 2 ? 'Item ' : 'Order'}}
    </v-btn> -->

  </div>

  
</template>

<script>

// import dashboard from './contents/dashboard'
import transaction from './contents/transaction'
import due from './contents/due'
import item from './contents/items'
import order from './contents/order'
import invoice from './contents/invoices'
// const transactionForms = require('../../config.js').configs.transactionForms;
let activityTabConfigs = require('../../config.js').configs.activityTabConfigs;
const navigationMenu = require('../../config.js').configs.bottomNavigation;
import {transactionMixin} from '../transactions/transaction_mixin'

// import dialogPermission from '../dialogs/dialog_permission';

// import ledgerStatement from '../masters/forms/ledgers/ledger_statement'

import dialogTransactionOptions from '../dialogs/dialog_transaction_options'

import paymentReminderCard from '../common/payment_reminder_card'

let tagId = 'activity'

  export default {
    mixins: [transactionMixin],
    components:{
      // 'dialog-permission': dialogPermission,
      // 'ledger-statement':ledgerStatement,
      'dialog-transaction-options':dialogTransactionOptions,
      'payment-reminder-card':paymentReminderCard
    },
    data () {
      return {
        tabs:[
            // {"id":1, "title":"Dashboard"},
            {"id":1, "title":"Transactions"},
            {"id":2, "title":"Parties"},
            {"id":3, "title":"Items"},
            {"id":4, "title":"Pending Orders"},
            {"id":5, "title":"Pending Invoices"}
        ],
        currentTabComponent:null,
        activeIndex: null,
        search:'',
        printData:null,
        printTemplate:null,
        previewTemplate:null,
      }
    },
    watch: {
      '$root.selectedLanguage': function(){
        this.fn_setBottomNavigation();
      }
    },
    methods: {

      fn_add: function(){
        let obj = {};
        obj.itemId = null;
        obj.lastScrollPos = window.pageYOffset;

        if(this.activeIndex == 0){
          this.fn_openDialogOptions();
        }
        else if(this.activeIndex == 1){

          obj.itemIndex = this.$refs['ref_duePayments'].listItemObject.items.length;
          localStorage.setItem("ledgers_items_state",JSON.stringify(obj));

          this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), routeToDisplay:true, groupTypeId:101}})
        }
        else if(this.activeIndex == 2){
          obj.itemIndex = this.$refs['ref_items'].listItemObject.items.length;
          localStorage.setItem("activity_items_state",JSON.stringify(obj));

          this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), inventory:1}});
        }
        else if(this.activeIndex == 3){

          obj.itemIndex = this.$refs['ref_orders'].listItemObject.items.length;
          localStorage.setItem("sale_items_state",JSON.stringify(obj));

          localStorage.setItem("SetDataDrive", 1);
          this.$router.push({path:'/transactions/sales/order/items/new', query:{tagId:this.guidWeb()}});
        }
      },

      fn_openDialogOptions: function(){
        this.$refs['ref_dialogTransactionOptions'].dialog_transaction_options = true;
      },

      fn_preview: function(item, formNameFn){
        item.toolbarTitle = formNameFn ? formNameFn(item) : 'order';
        let printType = item.invoiceTemplate == 101 ? 'ab' : item.invoiceTemplate == 201 ? 'sj' : null;

        let type = null;
        if(item.transactionListId == 10001 || item.transactionListId == 10002 || item.transactionListId == 10003 || item.transactionListId == 10004 || item.transactionListId == 10005){
          type = 'sales';
        }
        else if(item.transactionListId == 20001 || item.transactionListId == 20002 || item.transactionListId == 20003 || item.transactionListId == 20004 || item.transactionListId == 20005){
          type = 'purchase';
        }
        else if(item.transactionListId == 40002 || item.transactionListId == 40005 || item.transactionListId == 40006){
          type = 'inventory';
        }
        // else if(item.transactionListId == 40002){
        //   type = 'inventory';
        // }
        
        if(item.transactionListId == 40005)
          printType = 'st'
        if(item.transactionListId == 40006)
          printType = 'bm'

        this.fn_previewInvoice(true, type, printType, item);
      },

      fn_bindInvoiceTemplate: function(type, item){

        this.printTemplate = null;
        this.printData = null;
        this.previewTemplate = null;

        let templateNo = item.transactionListId == 40005 ? 301 : item.transactionListId == 40006 ? 302 : item.invoiceTemplate;  

        // this.printTemplate = require('../invoice_templates/invoices/template'+item.invoiceTemplate).default;
				if(this.$root.TransactionSettings.fullPagePrint && templateNo != 101 && templateNo != 301 && templateNo != 302){
          this.previewTemplate = require('../invoice_templates/invoices/template'+item.invoiceTemplate).default;
					this.printTemplate = require('../invoice_templates/invoices/template1001').default;
				}
				else{
					this.printTemplate = require('../invoice_templates/invoices/template'+templateNo).default;
				}
        // this.printTemplate = require('../invoice_templates/invoices/template1').default;
        console.log(this.printTemplate);

        // let dataFnName = item.invoiceTemplate == 101 ? 'AccountBookPrintData' : item.invoiceTemplate == 201 ? 'StockJournalPrintData' : 'InvoiceData';
         let dataFnName = templateNo == 101 ? 'AccountBookPrintData' : templateNo == 201 ? 'StockJournalPrintData' : templateNo == 301 ? 'StockTransferInvoiceData' : templateNo == 302 ? 'BOMInvoiceData' : 'InvoiceData';
         
        if(type=='sharewhatsapp'){
          this.fn_shareInvoice('sharewhatsapp', item, dataFnName);
        }
        else if(type=='print'){
          this.fn_getPrintData(dataFnName, item.transactionId, 'print', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
        }
        else if(type=='pdf'){
          this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
        }
        else if(type=='share'){
          this.fn_shareInvoice('share', item, dataFnName);
        }
        else if(type=='thermal'){
          this.fn_getPrintData(dataFnName, item.transactionId, 'thermal', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
        }

        setTimeout(() => {
					this.previewTemplate = null;
				}, 5000);
      },

      fn_shareInvoice: function(type, item, dataFnName){

        // if(item.transactionTypeFormName.toLowerCase() == "itc not eligible"){
        //   item.transactionTypeFormName = "Expense";
        // }

        let title = null;
        if(item.transactionListId==10003){
            title = "Invoice";
        }
        else{
            title = this.fn_getTransactionTitle(item.transactionListId);    
        }

        if(item.transactionPhoneNumber){
					item.primaryMobileNumber = item.transactionPhoneNumber;
				}

        let shareObj = {};
        shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
        shareObj.type = 'pdf';
        shareObj.primaryMobileNumber = item.primaryMobileNumber && type == 'sharewhatsapp' ? item.primaryMobileNumber : null;

        // if(item.transactionTypeFormName == "Retail Invoice" || item.transactionTypeFormName == "Wholesale Invoice" || item.transactionTypeFormName == "Export Invoice" || item.transactionTypeFormName ==  "Stock Transfer"){
        //     item.transactionTypeFormName = "Invoice";
        // }
            
        // shareObj.subject = title + " Details";
        shareObj.subject = title + " #" + item.mergeTransactionNumber + " from " + this.$root.CurrentBusiness.BusinessName;
        shareObj.email = item.email ? [item.email] : null ;

        let party = item.accountLedgerName ? item.accountLedgerName + ',' : '';

        //shareObj.textMessage = "Dear "+party+"\n\nBelow are your " + title + " details. Please find the attached pdf.\n\nTransaction Date: "+this.$moment(item.transactionDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(item.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
        shareObj.textMessage = this.$tShare('share.invoiceMessage', {
          party: party,
          title: title,
          number: item.mergeTransactionNumber,
          date: this.$moment(item.transactionDate).format('DD-MMM-YYYY'),
          amount: this.$root.numberToLocale(item.roundedAmount),
          businessName: this.$root.CurrentBusiness.BusinessName
        });

        this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', shareObj, item.mergeTransactionNumber, null, item.transactionListId);
      },

      fn_tabChange: function (tabIndex) {
        let self = this;
        activityTabConfigs.activeIndex = tabIndex;
        // if(tabIndex==0){
        //   this.currentTabComponent = dashboard;
        //   setTimeout(function(){
        //     self.$refs['ref_dashboard'].fn_dateRange(self.$root.activity.dashboard.defaultDateRange);
        //   },300);
        // }
        if(tabIndex==0){
          this.currentTabComponent = transaction;
          setTimeout(function(){
            self.$refs['ref_transactions'].fn_searchItem();
          },300);
        }
        else if(tabIndex==1){
          this.currentTabComponent = due;
          setTimeout(function(){
            self.$refs['ref_duePayments'].fn_searchItem();
          },300);
        }
        else if(tabIndex==2){
          this.currentTabComponent = item;
          setTimeout(function(){
            self.$refs['ref_items'].fn_searchItem();
          },300);
        }
        else if(tabIndex==3){
          this.currentTabComponent = order;
          setTimeout(function(){
            self.$refs['ref_orders'].fn_searchItem();
          },300);
        }
        else if(tabIndex==4){
          this.currentTabComponent = invoice;
          setTimeout(function(){
            self.$refs['ref_invoices'].fn_searchItem();
          },300);
        }
      },

      fn_setBottomNavigation : function () {

          console.log('set navigation');

          let self = this;

          let viewObject = {}

          viewObject.NavigationMenu = navigationMenu.map(item => Object.assign({}, item, { Text: this.$t('actions.bottomNav.' + item.Text.toLowerCase()) }));

          this.setBottomNavigation(tagId, viewObject, 
              {
                onSuccess: function (response) {
                  console.log(response);
                  localStorage.setItem('bottomNavigationSet', 1);
                  self.fn_showBottomNavigation();
                },
                onError: function (error) {
                  console.log(error);
                }
              }
          )
      },

      fn_showBottomNavigation: function () {

        let self = this;

        let navigationObject = {activeIndex: 1002};

        this.showBottomNavigation(tagId, navigationObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null, 
            onMenuItemClick: function (tagId, menuId, menuAction) {
              if(menuAction == 'filter'){
                self.$refs['ref_transactions'].fn_menuItemClick(tagId, menuId, menuAction);
              }
              else if(menuAction == 'createinvoice'){
                self.$refs['ref_orders'].fn_menuItemClick(tagId, menuId, menuAction);
              }
              else{
                self.$root.fn_bottomNavigationItemClick(tagId, menuId, menuAction)
              }
            }
          }
        );
      },

      fn_hideBottomNavigation: function () {

        this.hideBottomNavigation({
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }
          }
        );
        
      },

      fn_showWebView: function () {
        this.showWebView(tagId, {}, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
          }
        );
      },

      fn_goBack: function(){
        if(this.$refs['ref_transactions'].dialog_transaction_list){
          this.$refs['ref_transactions'].dialog_transaction_list = false;
        }
        else if(this.$refs['ref_duePayments'].$refs['ref_dialogFilterItems'] && this.$refs['ref_duePayments'].$refs['ref_dialogFilterItems'].dialog_filter_items){
          this.$refs['ref_duePayments'].$refs['ref_dialogFilterItems'].dialog_filter_items = false;
        }
        else if(this.$refs['ref_duePayments'].$refs['ref_dialogTransactionOptions'] && this.$refs['ref_duePayments'].$refs['ref_dialogTransactionOptions'].dialog_transaction_options){
          this.$refs['ref_duePayments'].$refs['ref_dialogTransactionOptions'].dialog_transaction_options = false;
        }
        else if(this.$refs['ref_dialogTransactionOptions'].dialog_transaction_options){
          this.$refs['ref_dialogTransactionOptions'].dialog_transaction_options = false;
        }
        else if(this.$refs['ref_invoices'].dialog_datepicker){
          this.$refs['ref_invoices'].dialog_datepicker = false;
        }
        else if(this.$refs['ref_invoices'].$refs['ref_dialogMarkClear'] && this.$refs['ref_invoices'].$refs['ref_dialogMarkClear'].dialog_mark){
          if(this.$refs['ref_invoices'].$refs['ref_dialogMarkClear'].confirmSheet){
            this.$refs['ref_invoices'].$refs['ref_dialogMarkClear'].confirmSheet = false;
          }
          else{
            this.$refs['ref_invoices'].$refs['ref_dialogMarkClear'].closeDialogWeb();
          }
        }
        else{
          this.exitApp();
        }
      },


      // fn_goBack: function(){
      //   if(this.$refs['ref_dashboard'].dialog_datepicker){
      //     this.$refs['ref_dashboard'].dialog_datepicker = false;
      //   }
      //   else if(this.$refs['ref_dashboard'].dialog_custom_dates){
      //     this.$refs['ref_dashboard'].dialog_custom_dates = false;
      //   }
      //   else if(this.$refs['ref_transactions'].dialog_transaction_list){
      //     this.$refs['ref_transactions'].dialog_transaction_list = false;
      //   }
      //   else if(this.$refs['ref_duePayments'].$refs['ref_dialogFilterItems'] && this.$refs['ref_duePayments'].$refs['ref_dialogFilterItems'].dialog_filter_items){
      //     this.$refs['ref_duePayments'].$refs['ref_dialogFilterItems'].dialog_filter_items = false;
      //   }
      //   else{
      //     this.exitApp();
      //   }
      // },

      // fn_openPermissionDialog: function(permissionType){
      //   this.$root.permissionType = permissionType;
      //   this.$refs['ref_dialogPermission'].dialog_permission = true;
      // },

      // fn_closeDialog: function(){
      //   this.$refs['ref_dialogPermission'].dialog_permission = false;
      // }

    },
    mounted: function () {
      if(activityTabConfigs.activeIndex != null){
        this.activeIndex = activityTabConfigs.activeIndex;
        this.fn_tabChange(this.activeIndex, true);
      }

      window.js_globals.fn_onBackPress = this.fn_goBack;
      // window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
    },
    beforeRouteLeave(to, from, next){
      if(to.name!="reports" && to.name!="activitytabs" && to.name!="actions" && to.name!="notifications" && to.name!="settings"){
        this.fn_hideBottomNavigation();
      }

      // if(this.$refs['ref_dialogPermission'].dialog_permission){
      //   this.$refs['ref_dialogPermission'].closeDialogWeb();
      //   next(false);
      // }
      // else{
      //   next();
      // }
      next();
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
          if(from.name!="reports" && from.name!="activitytabs" && from.name!="actions" && from.name!="notifications" && from.name!="settings"){
            vm.fn_showWebView();
          }
          else{
            localStorage.removeItem('activity_party_filter');
            localStorage.removeItem('activity_item_filter');
            localStorage.removeItem('activity_transaction_filter');
          }

          let bottomNavigationSet = Number(localStorage.getItem('bottomNavigationSet'))
          console.log(bottomNavigationSet);

          if(bottomNavigationSet){
            vm.fn_showBottomNavigation();
          }
          else{
            vm.fn_setBottomNavigation();
          }

          // vm.fn_showBottomNavigation();
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/activity/tabs.vue